import { ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const usePortal = (id?: string) => {
  const [targetElement, setTargetElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (!id) return;

    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement('div');
      el.id = id;
      document.body.appendChild(el);
    }

    setTargetElement(el);

    // optional cleanup
    return () => {
      // el.remove();
    };
  }, [id]);

  const render = (children: ReactNode) => {
    if (!targetElement) return null; // render nothing until target exists
    return createPortal(children, targetElement);
  };

  return { render };
};
